/** The pale gold of progress: the loading bar's fill, and the ring of an ability cooling down. */
export const PROGRESS_GOLD = '#d9a93a';
